import { render, staticRenderFns } from "./DeletePackageModal.vue?vue&type=template&id=d7ddcb12&scoped=true"
import script from "./DeletePackageModal.vue?vue&type=script&lang=js"
export * from "./DeletePackageModal.vue?vue&type=script&lang=js"
import style0 from "./DeletePackageModal.vue?vue&type=style&index=0&id=d7ddcb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ddcb12",
  null
  
)

export default component.exports